"use client";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";

import { HomepageHeroImageButton } from "./HomepageHeroImage.types";

type HomepageHeroImageBenefitsProps = {
  items: string[];
  shop: HomepageHeroImageButton;
};

const HomepageHeroImageBenefits = ({ items, shop }: HomepageHeroImageBenefitsProps) => (
  <div className="mx-auto max-w-[330px] md:max-w-[527px] xl:mx-0 xl:max-w-[800px]">
    <div className="relative flex flex-col items-center xl:min-h-[263px] xl:items-start min-[1440px]:min-h-[233px] [@media(min-width:1280px)_and_(max-height:899px)]:min-h-[194px]">
      {items.map((item) => (
        <div
          key={item}
          className="flex items-center text-center xl:text-left [&:not(:last-of-type)]:pb-4"
        >
          <TextElementNova
            text={item}
            element="p"
            className="[@media(min-width:1280px)_and_(max-height:899px)]:!text-[18px]"
            classes={{
              default: "Body-20-Dia-Normal",
              768: "Body-30-Dia-Normal",
              1024: "Body-30-Dia-Normal",
            }}
          />
        </div>
      ))}
    </div>
    <div className="mx-auto w-[133px] pt-8 pb-10 md:w-[136px] md:pb-12 xl:mx-0 xl:w-[146px] xl:pt-10 xl:pb-0">
      <ButtonNova
        icon="Right"
        label="Shop Now"
        className="lifestage-cta"
        ctaLink={shop.ctaLink}
        trackObject={{
          destination: shop.ctaLink,
          name: "Marketing CTA Clicked",
          module_name: "lifestage",
          type: "button",
        }}
      />
    </div>
  </div>
);

export default HomepageHeroImageBenefits;
